import React, { useCallback, useState } from 'react';
import '../../../../scss/common/buttons.scss';
import { observer } from 'mobx-react';
const ButtonGroup = observer(({
  onClick = null,
  className = '',
  elements = []
}) => {
  const [value, setValue] = useState(elements[0].value);
  const onButtonClick = useCallback(newValue => {
    setValue(newValue);
    if (onClick) {
      onClick(newValue);
    }
  }, [onClick]);
  return /*#__PURE__*/React.createElement("div", {
    className: `${className} cms-button-group`
  }, elements.map((el, index) => {
    return /*#__PURE__*/React.createElement("span", {
      key: index,
      onClick: () => {
        onButtonClick(el.value);
      },
      className: `button-group-element ${value === el.value ? 'active' : ''}`
    }, el.label);
  }));
});
export default ButtonGroup;